import { render, staticRenderFns } from "./AcoesSolicitarReenvioDocumento.vue?vue&type=template&id=1d72af10&scoped=true"
import script from "./AcoesSolicitarReenvioDocumento.vue?vue&type=script&lang=js"
export * from "./AcoesSolicitarReenvioDocumento.vue?vue&type=script&lang=js"
import style0 from "./AcoesSolicitarReenvioDocumento.vue?vue&type=style&index=0&id=1d72af10&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d72af10",
  null
  
)

export default component.exports